<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" x="0px" y="0px" viewBox="0 0 32 32" :class="svgClassName"><title>Zatvori</title><path d="M29,30.3c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.5-0.1,0.6-0.3c0.3-0.4,0.3-0.9,0-1.2l-13-13l13-13c0.3-0.3,0.3-0.9,0-1.2
	c-0.2-0.2-0.4-0.3-0.6-0.3c-0.2,0-0.5,0.1-0.6,0.2l-13,13L3,1.7c-0.3-0.3-0.9-0.3-1.2,0C1.4,2.1,1.4,2.6,1.7,3l13,13l-13,13
	c-0.3,0.3-0.3,0.9,0,1.2c0.3,0.4,0.9,0.4,1.2,0l13-13L29,30.3l-0.2,0.2L29,30.3z"/></svg>
</template>

<script>
export default {
  name: "CloseIcon",
  props: {
    svgClassName: {
      type: String,
      default: ""
    }
  }
}
</script>